// removed by extract-text-webpack-plugin
module.exports = {"widgets":"_3VbnrvfdDzdQjwunuleXes","refreshBtn":"_2YfHs7C-iIQVg6bt828X3C","idCol":"_3gXnt1S3DhQYmrCKr_zabq","colorCol":"_26SGuTlEIKU7sfrSTGSfTB","sprocketsCol":"WvE6BNDtMxC3nbdpug7mK","ownerCol":"_1UhxOmONNOni_Yhaocn9QM","buttonCol":"_2BobxRq4ydkk90m_EFlwmM","saving":"_1S4NAmZIcKslIw6Si7vVR5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Widgets/Widgets.scss
// module id = 489
// module chunks = 0